"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const EmailIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "22", height: "14", viewBox: "0 0 22 14", fill: "none" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.0018 2L11.0018 6.50006L5.00082 2H17.0018ZM19 3.00138L11.6018 8.55003C11.2463 8.81668 10.7574 8.8167 10.4019 8.55007L3 2.99947V12H19V3.00138ZM1.011 0.851183C0.999951 0.921412 0.996138 0.99286 0.999999 1.0642V13C0.999999 13.5523 1.44771 14 2 14H20C20.5523 14 21 13.5523 21 13V1.097C21.0471 0.557372 20.6505 0 20.0018 0H20H2.00048H2C1.99712 0 1.99425 1.2364e-05 1.99138 3.65703e-05C1.58499 0.00330936 1.27861 0.225897 1.1199 0.524813C1.06591 0.624599 1.02839 0.734605 1.011 0.851183Z", fill: color !== null && color !== void 0 ? color : theme.colors.white, stroke: color !== null && color !== void 0 ? color : theme.colors.white, strokeWidth: "0" }) })));
};
exports.EmailIcon = EmailIcon;
//# sourceMappingURL=email_icon.js.map